import { Maybe } from 'types/FMSGraphqlTypes'
import { IMotorCarrierInfoFragment } from '../graphql/MotorCarrierInfoFragment'
import { IUsersMotorCarriersQuery } from '../graphql/UsersMotorCarriers'

export const isJoinRequestPending = ({
  joinRequests,
  motorCarrierId,
}: {
  joinRequests: IUsersMotorCarriersQuery['motorCarrierJoinRequestsForUser']
  motorCarrierId: Maybe<IMotorCarrierInfoFragment['id']>
}): boolean => {
  if (!joinRequests || !motorCarrierId) {
    return false
  }
  return joinRequests.some(
    ({ approvedAt, motorCarrier }) => motorCarrier.id === motorCarrierId && !approvedAt
  )
}
